import * as React from "react";

import { Button } from "~/ui";
import { Modal } from "~/ui/legacyFellowIndex";

import styles from "./MicrosoftTodo.module.css";

interface Props {
	onClose: (removed: boolean) => void;
	listName: string;
}

export default function MicrosoftTodoRemoveListModal({ listName, onClose }: Props): JSX.Element {
	const onRemoveList = React.useCallback(() => {
		onClose(true);
	}, [onClose]);

	const onCancel = React.useCallback(() => onClose(false), [onClose]);

	return (
		<Modal onClose={onCancel} width="31.25em">
			<Modal.Header noBottomBorder onClose={onCancel}>
				<Modal.Title>
					Are you sure you want to remove the list <strong>{listName}</strong>?
				</Modal.Title>
			</Modal.Header>
			<Modal.Body textOnly className={styles.removeListModalBody}>
				Removing this list will prevent any further action items from syncing with Microsoft To Do.
			</Modal.Body>
			<Modal.Footer>
				<Button size="normal" onClick={onCancel}>
					Cancel
				</Button>
				<Button size="normal" variant="destructive" onClick={onRemoveList}>
					Remove
				</Button>
			</Modal.Footer>
		</Modal>
	);
}
